import type { OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import { textVariants } from '@freelancer/ui/tailwind-text';
import { TextSize } from '@freelancer/ui/text';
import { WorkedTimeSizeType } from './worked-time.types';

@Component({
  selector: 'fl-worked-time',
  template: `
    <fl-icon
      class="DollarIcon"
      [name]="'ui-clock-v2'"
      [size]="size"
      [sizeTablet]="sizeTablet"
      [sizeDesktop]="sizeDesktop"
      [color]="IconColor.SUCCESS"
      [flMarginRight]="'xxxsmall'"
    ></fl-icon>
    <p
      [class]="workedTimeClass"
      [matTooltip]="tooltipMessage"
      [matTooltipPosition]="'below'"
    >
      {{ time | number: '1.1-1' }}
    </p>
  `,
  styleUrls: ['./worked-time.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkedTimeComponent implements OnChanges, OnInit {
  IconColor = IconColor;
  IconSize = IconSize;

  private workedTextSize: TextSize;
  private workedTextSizeTablet?: TextSize | undefined;
  private workedTextSizeDesktop?: TextSize | undefined;

  workedTimeClass: string;

  @Input() time?: number;
  @Input() tooltipMessage = 'Hours of experience working on similar projects';
  @Input() size: WorkedTimeSizeType = IconSize.SMALL;
  @Input() sizeTablet?: WorkedTimeSizeType;
  @Input() sizeDesktop?: WorkedTimeSizeType;

  ngOnInit(): void {
    this.calculateStyles();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      'size' in changes ||
      'sizeTablet' in changes ||
      'sizeDesktop' in changes
    ) {
      this.calculateStyles();
    }
  }

  private calculateStyles(): void {
    this.getFontSize();

    this.workedTimeClass = textVariants({
      size: this.workedTextSize,
      sizeTablet: this.workedTextSizeTablet,
      sizeDesktop: this.workedTextSizeDesktop,
    });
  }

  private generateFontSize(
    size: WorkedTimeSizeType | undefined,
  ): TextSize | undefined {
    if (!size) return undefined;

    switch (size) {
      case IconSize.SMALL:
        return TextSize.XXSMALL;
      case IconSize.MID:
        return TextSize.SMALL;
      default:
        return size;
    }
  }

  private getFontSize(): void {
    this.workedTextSize = this.generateFontSize(this.size) || TextSize.XXSMALL;
    this.workedTextSizeTablet = this.generateFontSize(this.sizeTablet);
    this.workedTextSizeDesktop = this.generateFontSize(this.sizeDesktop);
  }
}
